import { render, staticRenderFns } from "./CostOverview.vue?vue&type=template&id=58ac2ace&scoped=true&"
import script from "./CostOverview.vue?vue&type=script&lang=js&"
export * from "./CostOverview.vue?vue&type=script&lang=js&"
import style0 from "./CostOverview.vue?vue&type=style&index=0&id=58ac2ace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ac2ace",
  null
  
)

export default component.exports